import { useCallback, useState } from "react"
import type { Case } from "../../api/types.ts"
import { OrphanLinkPanel, type OrphanRow } from "./OrphanLinkPanel.tsx"

/**
 * 무적화물을 접수 건에 잇는 길. **입고 스캔 화면과 무적화물 전용 화면이 이 하나를 쓴다.**
 *
 * 잇기는 옆판 하나(`OrphanLinkPanel`)가 전부 한다 — 이을 건을 찾고, 고르면
 * `POST /api/scan/orphans/:id/link` 를 한 번 부른다. 검증(번호가 이미 적힌 건·이미 입고된
 * 건·이미 이은 상자)은 모두 서버에 있다. 화면이 두 곳이어도 같은 요청 한 줄을 지나므로
 * 어느 화면에서 이어도 결과가 같다.
 *
 * 여닫는 상태만 여기 둔다. 각 화면은 이은 뒤에 **자기 화면에서 다시 읽을 것**을
 * `onLinked` 에서 처리한다(스캔 화면은 배너와 오늘 스캔, 전용 화면은 목록).
 *
 * `useCaseDetailPanel` 과 같은 모양이다 — 화면은 `start(상자)` 를 부르고 `panel` 을 그린다.
 */
export function useOrphanLink({ onLinked }: { onLinked: (linked: Case) => void }) {
  const [target, setTarget] = useState<OrphanRow | null>(null)

  const start = useCallback((orphan: OrphanRow) => setTarget(orphan), [])
  const close = useCallback(() => setTarget(null), [])

  const panel =
    target === null ? null : (
      <OrphanLinkPanel orphan={target} onClose={close} onLinked={onLinked} />
    )

  return { start, close, panel, target }
}
